import { IMainScope } from '../../app/IMainScope';
import { IPlaceTitleScope } from '../../app/IPlaceTitleScope';
import { ISubplaceCountsScope, SubplaceCountsHelper, SubplaceEvents } from '../helpers/SubplaceCountsHelper';
import { IPlace } from '../models/IPlace';
import { Module } from '../Module';
import { CreateSiteAction } from '../services/CreateSiteAction';

export interface ISitesPlaceScope extends IMainScope, IPlaceTitleScope, ISubplaceCountsScope {
}

export class SitesPlaceCtrl {

  public static $inject = [
    '$location',
    '$scope',
    '$state',
    'CreateSiteAction',
    'place'
  ];

  constructor(
    $location: ng.ILocationService,
    $scope: ISitesPlaceScope,
    $state: ng.ui.IStateService,
    CreateSiteAction: CreateSiteAction,
    place: IPlace
  ) {
    SubplaceCountsHelper.keepSubplaceCountsUpdated($scope, place);

    $scope.placeTitleClicked = () => {
      $scope.$broadcast(SubplaceEvents.Refresh);
    };
  }

}

Module.instance().controller('SitesPlaceCtrl', SitesPlaceCtrl);
